"use strict";
var Observable_1 = require('../../Observable');
var filter_1 = require('../../operator/filter');
Observable_1.Observable.prototype.filter = filter_1.filter;
//# sourceMappingURL=filter.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/filter.js